import { CircleAlert, Inbox, RefreshCw } from "lucide-react";
import type { ReactNode } from "react";

export function LoadingState({ label = "正在读取内容" }: { label?: string }) {
  return (
    <div className="space-y-3" role="status" aria-busy="true" aria-label={label}>
      {[1, 2, 3, 4].map((value) => <div key={value} className="skeleton h-24" aria-hidden="true" />)}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <section className="card flex flex-col items-start gap-3 border-[var(--color-danger)] p-5" role="alert">
      <div className="flex items-center gap-2 font-semibold"><CircleAlert size={20} aria-hidden="true" />暂时无法读取数据</div>
      <p className="text-sm text-muted">{message}</p>
      {onRetry ? <button className="btn-secondary" onClick={onRetry}><RefreshCw size={17} />重试</button> : null}
    </section>
  );
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return (
    <section className="card flex min-h-64 flex-col items-center justify-center p-8 text-center">
      <span className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-subtle text-muted" aria-hidden="true"><Inbox /></span>
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="mt-1 max-w-md text-sm leading-relaxed text-muted">{description}</p>
      {action ? <div className="mt-5">{action}</div> : null}
    </section>
  );
}
